'use strict';
(function (module) {
    module.factory('enqueueExport', [
        '$q',
        '$timeout',
        'exportService',
        '$rootScope',
        '$routeParams',
        function ($q, $timeout, exportService, $rootScope, $routeParams) {
            var POLL_INTERVAL = 5000;
            var enqueueExport;
            function waitForExport(containerId, namespace, key, cb) {
                exportService.getExportStatus(containerId, namespace, key)
                    .then(function (res) {
                    res.data = res.data || {};
                    if (res.data.pending === false) {
                        // download export
                        exportService.downloadExport(containerId, namespace, key);
                        cb();
                    }
                    else if (res.data.pending === true) {
                        // keep waiting for Export
                        $timeout(function () {
                            waitForExport(containerId, namespace, key, cb);
                        }, POLL_INTERVAL);
                    }
                    else {
                        cb('An unexpected error has occured');
                    }
                })
                    .catch(function (err) {
                    cb(err);
                });
            }
            function registerListener() {
                // options - jobData info
                // cb returned with (namespace, key) if succesful, otherwise undefined
                if (enqueueExport) {
                    //we've already attached the listener let's not kill ourselves
                    clearHandler();
                }
                enqueueExport = $rootScope.$on('enqueueExport', function (evt, options, cb) {
                    if (!options.surveyId) {
                        options.surveyId = $routeParams.surveyId;
                    }
                    exportService.enqueueExport(options)
                        .then(function (res) {
                        res.data = res.data || {};
                        waitForExport(options.containerId, res.data.namespace, res.data.key, cb);
                    })
                        .catch(function (err) {
                        cb(err);
                    });
                });
                $rootScope.$on('$destroy', clearHandler);
            }
            function clearHandler() {
                if (_.isFunction(enqueueExport)) {
                    enqueueExport();
                }
            }
            return {
                registerListener: registerListener
            };
        }
    ]);
})(angular.module('reporting.dashboards.services'));
